import { isStaging } from '@/helpers/environment'

const stagingPaywallStructure = {
  default: {
    layout: 'vertical',
    selected_index: 0,
    most_popular: 0,
    products: ['1week', '1month', '1year'],
    discountIds: ['weekly_intro_60', 'monthly_intro_60', 'yearly_intro_60'],
    discountRates: [0.6003, 0.6001, 0.60004],
  },
  countdown_discount_1: {
    layout: 'vertical',
    selected_index: 0,
    most_popular: 0,
    products: ['1week', '1month', '1year'],
    discountIds: ['weekly_intro_60', 'monthly_intro_60', 'yearly_intro_60'],
    discountRates: [0.6003, 0.6001, 0.60004],
  },
}

const productionPaywallStructure = {
  default: {
    layout: 'vertical',
    selected_index: 0,
    most_popular: 0,
    products: ['1week', '1month', '1year'],
    discountIds: ['weekly_intro_60', 'monthly_intro_60', 'yearly_intro_60'],
    discountRates: [0.6003, 0.6001, 0.60004],
  },
  countdown_discount_1: {
    layout: 'vertical',
    selected_index: 0,
    most_popular: 0,
    products: ['1week', '1month', '1year'],
    discountIds: ['weekly_intro_60', 'monthly_intro_60', 'yearly_intro_60'],
    discountRates: [0.6003, 0.6001, 0.60004],
  },
}

const stagingIapCatalog = {
  '1week': {
    t8: 'pri_01kq7b8dg1b6fheqkwxg0zzwrk',
  },
  '1month': {
    t8: 'pri_01kq7b8dpmkw5z8yj2g1cqrc43',
  },
  '1year': {
    t8: 'pri_01kq7b8dwtryzdbtxaes53jh4j',
  },
}

const productionIapCatalog = {
  '1week': {
    t8: 'pri_01kqy3bw73jp5sxvrdb5je1r12',
  },
  '1month': {
    t8: 'pri_01kqy3bxgkrscpvvrfgrpr37rf',
  },
  '1year': {
    t8: 'pri_01kqy3bytdgmq3qfr40n17cdz9',
  },
}

const stagingIadCatalog = {
  weekly_intro_60: 'dsc_01kq7b8swv32j0ghgegwekfhzt',
  monthly_intro_60: 'dsc_01kq7b8t33gbyhjj1mqvnxpec5',
  yearly_intro_60: 'dsc_01kq7cacwy425nrb8x5an4hjae',
}

const productionIadCatalog = {
  weekly_intro_60: 'dsc_01kqy3c7sm0n5aacbag27pwx5q',
  monthly_intro_60: 'dsc_01kqy3c98ths1w3b13m7x3nesm',
  yearly_intro_60: 'dsc_01kqy3cbsqva5ek5mad33jebcc',
}

export const DEFAULT_PRICING_TIER = 't8'

export const defaultPaywallConfig = {
  paywallStructure: isStaging
    ? stagingPaywallStructure
    : productionPaywallStructure,
  iapCatalog: isStaging ? stagingIapCatalog : productionIapCatalog,
  iadCatalog: isStaging ? stagingIadCatalog : productionIadCatalog,
}
